import ajax from './ajax';

const host = process.env.NODE_ENV === 'development' ? '' : location.origin.replace(/miniapp/, 'mall-mng');
const prefix = /mall/.test(window.location.host) ? '/mall-b/miniapp' : process.env.API_PREFIX;
const prefixChannel = '/miniapp-b/miniapp'
export default {
    shop: {
        getCompanyInfo() {
            return ajax.get(prefix + '/shop/user/view').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response);
                }
            });
        },
        getAppList(param = {}) {
            return ajax.get(prefix + '/shop/app/list', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getAppDetail(param = {}) {
            return ajax.get(prefix + '/shop/app/view', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getChannelBindInfo(param = {}) {
            return ajax.get(prefixChannel + '/channel/miniapp/getChannelBindInfo', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getAppMinVersionList(param = {}) {
            return ajax.post(prefixChannel + '/channel/miniapp/getChannelBindInfolist', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        updateMinVersionNew(param = {}) {
            return ajax.post(prefixChannel + '/channel/miniapp/updateChannelBindInfo', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        updateSuspendInfo(param = {}) {
            return ajax.post(prefixChannel + '/channel/miniapp/updateChannelStatusInfo', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getUpList(param = {}) {
            return ajax.post(prefix + '/shop/up/list', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        cancelAction(param = {}) {
            return ajax.post(prefix + '/shop/up/status/update', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        checkMid(param = {}) {
            return ajax.get(prefix + '/shop/user/name', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        deleteConnection(param = {}) {
            return ajax.get(prefix + '/shop/up/delete', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        addInvite(param = {}) {
            return ajax.post(prefix + '/shop/up/link', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        checkName(param = {}) {
            return ajax.get(prefix + '/shop/name/valid', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        postFile(param = {}) {
            let formData = new FormData();
            formData.append('logo', param.logo);
            formData.append('x', param.x);
            formData.append('y', param.y);
            formData.append('width', param.xCutSize);
            formData.append('height', param.yCutSize);
            return ajax.postFile(prefix + '/shop/logo/upload', formData).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        changeLogo(param = {}) {
            return ajax.post(prefix + '/shop/logo/update', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        changeName(param = {}) {
            return ajax.post(prefix + '/shop/name/update', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        changeIntro(param = {}) {
            return ajax.post(prefix + '/shop/introduction/update', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getMemberList(param = {}) {
            return ajax.get(prefix + '/shop/members', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        addMembers(param = {}) {
            return ajax.post(prefix + '/shop/members', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        modifyMembers(param = {}) {
            return ajax.put(prefix + '/shop/members', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        searchByMid(param = {}) {
            return ajax.get(prefix + '/shop/members/users', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 查看企业支付能力
        getAccountInfo() {
            return ajax.get(prefix + '/shop/company/pay/info').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getChannel(param = {}) {
            return ajax.post(prefixChannel + '/channel/miniapp/bind/search', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getStorage(param = {}) {
            return ajax.get(prefix + '/shop/channel/storage/all', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getAllChannelStorage(param = {}) {
            return ajax.get(prefix + '/shop/channel/storage/allChannel', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 获取企业见证宝状态
        getCompanyStatus() {
            return ajax.get(prefix + '/shop/company/witness/login/info').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        deletDevVer(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/development/delete', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 查看小程序支付能力
        getPaymentInfo(param = {}) {
            return ajax.get(prefix + '/shop/pay/info', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        deleteAudVer(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/check/delete', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        devVerSubmit(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/development/check/submit', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        publish(param = {}) {
            return ajax.put(prefix + '/shop/channel/storage/check/gray/publish', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 全量发布-->立即发布
        fullPublish(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/immediate/publish', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 全量发布-->定时发布
        timerPublish(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/timer/publish/submit', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 全量发布-->定时发布-->立即发布
        immediatePublish(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/timer/immediate/publish', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 灰度发布
        grayPubing(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/gray/publish', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 灰度发布 --> 立即发布
        grayToProduct(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/gray/immediate/publish', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 全量发布-->定时发布-->取消定时发布
        cancelTimerPub(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/timer/publish/cancel', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        stopGray(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/gray/stop', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        submitGrayCheck(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/gray/check/submit', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        recallGrayCheck(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/gray/check/recall', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getCats(param = {}) {
            return ajax.get(prefix + '/shop/cats', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getDomainList(param = {}) {
            return ajax.get(prefix + '/shop/url/info', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getModifyLimit(param = {}) {
            return ajax.get(prefix + '/shop/url/limit', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getServerLimit(param = {}) {
            return ajax.get(prefix + '/shop/url/total_limit', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        modifyServerDomain(param = {}) {
            return ajax.post(prefix + '/shop/url', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        //线上版本回退
        rollbackProductVersion(param = {}) {
            return ajax.post(prefix + '/shop/channel/storage/product/rollback', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 服务设置
        updateServiceStatus(param = {}) {
            return ajax.post(prefix + '/shop/suspend/status/update', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getBaseVersionList(param = {}) {
            // return ajax.get(prefix + '/shop/base/version', param).then(response => { // TODO
            return ajax.get(prefix + '/shop/base/version/history/list', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response);
                }
            });
        },
        updateMinVersion(param = {}) {
            return ajax.post(prefix + '/shop/minVersion/update', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        addDevices(param = {}) {
            return ajax.post(prefix + '/shop/members/buvid/add', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        updateDevices(param = {}) {
            return ajax.post(prefix + '/shop/members/buvid/update', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        //动态分享信息修改
        updateDynamicInfo(param = {}) {
            return ajax.post(prefix + '/shop/dynamic/update', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        getAppletLogList(param = {}) {
            return ajax.get(prefix + '/shop/base/version/history/list', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        }
    },
    up: {
        getUpInfo() {
            return ajax.get(prefix + '/up/user/view').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response);
                }
            });
        },
        getUpAppList() {
            return ajax.get(prefix + '/up/app/list').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response);
                }
            });
        },
        upStatusUpdate(param = {}) {
            return ajax.get(prefix + '/up/app/status/update', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        postFile(param = {}) {
            let formData = new FormData();
            formData.append('logo', param.logo);
            formData.append('x', param.x);
            formData.append('y', param.y);
            formData.append('width', param.xCutSize);
            formData.append('height', param.yCutSize);
            return ajax.postFile(prefix + '/up/logo/upload', formData).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        checkName(param = {}) {
            return ajax.get(prefix + '/up/name/valid', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        changeLogo(param = {}) {
            return ajax.post(prefix + '/up/logo/update', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        changeName(param = {}) {
            return ajax.post(prefix + '/up/name/update', param).then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        },
        // 修改小程序简介
        modifyIntro(param = {}) {
            return ajax.post(prefix + '/up/introduction/update', param, 'json').then(response => {
                if (response.code === 0) {
                    return response.data;
                } else {
                    return Promise.reject(response.message);
                }
            });
        }
    },
    logout(param = {}) {
        return ajax.get('/miniapp-b/user/logout').then(response => {
            if (response.code === 0) {
                return response.data;
            } else {
                return Promise.reject(response.message);
            }
        });
    }
};


// WEBPACK FOOTER //
// ./src/lib/dao.js